import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaIconComponent } from '../../atoms';
import { faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';
import { IconProp } from '@fortawesome/angular-fontawesome/types';
import { SizeProp } from '@fortawesome/angular-fontawesome';

export interface ContextMenuItem {
  label?: string;
  icon?: IconProp;
  clickValue?: any;
  divider?: boolean;
  iconClass?: string;
  iconSize?: SizeProp;
}

@Component({
  selector: 'orbit-context-menu',
  standalone: true,
  imports: [CommonModule, FaIconComponent, TranslatePipe],
  templateUrl: './context-menu.component.html',
  styleUrl: './context-menu.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuComponent {
  menuClick = output<string>();
  itemClicked = output<any>();
  items = input<ContextMenuItem[]>();
  readonly bubbleArrow = faCaretUp;
}
